//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'


//#endregion

import { OpDataList } from '../../../../models/util/op-data-list'
import { IReferenceType, IOpObject, IOpData } from '../../../../models/util/interfaces'
import { OpDataType } from '../../../../models/core/op-data-type'
import { OpDataTypeInGroup } from '../../../../models/core/op-data-type-in-group'
import { OpLocation } from '../../../../models/core/op-location';
import { OpCoord } from '../../../../models/custom/op-map-area';
import { FieldNameValueModel } from '../../../api/api.models'
import { CommonHelper } from '../../../../helpers/common-helper'
import { Md5 } from './../../../../helpers/md5-helper'
import { EventsNames } from '../../../../helpers/events-names'
import { Api, LocalDictionaryFactory } from '../../../api/api.module'
import { CommonCreateEdit, CreateEditField, CreateEditSection, CreateEditFieldSettings } from './../../../common/common.create-edit'
import { Enums } from '../../../../models/common/enums'
import { Dictionary } from '../../../../helpers/dictionary'
import { ReferenceTypeComponent } from '../../../../helpers/reference-type-component'
import { ConfigHelper } from '../../../../helpers/config-helper'
import { LocalizationHelper } from '../../../../helpers/localization-helper'
import { TypeHelper } from '../../../../helpers/type-helper'
import { ChangeStatusSelectItem } from './../../../common/change-status/change-status.directive.controller'
import { ConvertHelper } from './../../../../helpers/convert-helper'
import { TemplateHelper, ToastHelper } from '../../../../helpers'
import { IMRAccordionItemOptions, IMRAccordionOptions } from './../../../common/accordion'
import { LocationConfigurationFormKingspanOptions, KingspanCreateEditInitparams } from '../../../locations/location-configuration-form-kingspan'
import { CreateEditPopupOptions } from '../../../common/create-edit-popup/create-edit-popup.controller'
import { UserSessionService } from '../../../../services/user-session'

type SelectPopoverData = {
    valueId: number,
    dataTypeId: number,
    value: string
}

type LocationData = {
    city?: string,
    address?: string,
    zip?: string,
    lat?: number,
    lng?: number
}

interface KingspanCreateEditScope extends ng.IScope {
    // popup
    popupOptions: DevExpress.ui.dxPopupOptions
    closeButtonOptions: DevExpress.ui.dxButtonOptions
    popupVisible: boolean
    modelId: number
    tabsOptions: DevExpress.ui.dxTabsOptions
    tabsVisible: boolean;
    tabItems: { template: (itemData: any, itemIndex: number, itemElement: HTMLElement) => string }[]
    panels: CreateEditSection[]
    dateFormat: string
    selectedTab: number
    isLoading: boolean
    noData: boolean

    locationDataChangePopupId: string

    toolbarOptions: DevExpress.ui.dxToolbarOptions

    options: CreateEditPopupOptions

    // location type
    getCoords(): any
    onLocationSelected(lat: number, lng: number): void
    onPopoverValueIdSelected(valueId: number, dataTypeId: number, value: string): void

    // types / lists
    typeListsNames: string[]

    locationData: LocationData
    confirmNoChangePrevLocationData: () => void

    kingspanAccordionsOptions: IMRAccordionOptions
    kingspanFormAccordionItemOptions: IMRAccordionItemOptions
    kingspanDeviceAccordionItemOptions: IMRAccordionItemOptions
    kingspanDeviceFormOptions: LocationConfigurationFormKingspanOptions

    //localization
    confirmText: string
    noDataText: string
}

export class KingspanCreateEditPopupController extends CommonCreateEdit {
    private originalData: CreateEditField[]

    private tabs: DevExpress.ui.dxTabs
    private entityId: number = null

    // select boxes and events for distributor
    private distributorFormInstance: DevExpress.ui.dxSelectBox
    private distributorChangedEvent: any = null
    private distributorGridChangedEvent: any = null
    private hideDistributorChangePopup: boolean = false

    private selectedPopoverData: SelectPopoverData[] = []

    private popup: DevExpress.ui.dxPopup

    private previousSectionState: string
    private submitFailed: boolean = false

    private isClosed: boolean
    private idReferenceType: number

    private referenceObject: IReferenceType & IOpObject

    constructor(
        protected $scope: KingspanCreateEditScope,
        private $compile: ng.ICompileService,
        protected $q: ng.IQService,
        protected $timeout: ng.ITimeoutService,
        protected api: Api,
        protected localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService) {
        super($scope, api, localDictionary, $q, $timeout, userSession)

        this.setOptions()
        this.setEvents()
    }

    //#region Events

    private setEvents(): void {
        this.$scope.$on(EventsNames.ESC_KEY_PRESS, () => {
            if (this.$scope.popupOptions != null) {
                this.$timeout(() => {
                    this.closeDetails()
                })
            }
        })

        // show popup
        this.$scope.$on(EventsNames.SHOW_CREATE_EDIT_POPUP, (event, ...args: any[]) => {
            this.onShowCreateEditPopup()
        })

        // initialize panels with forms and grids
        this.$scope.$on(EventsNames.OPEN_CREATE_EDIT_POPUP_KINGSPAN, (event: ng.IAngularEvent, ...args: any[]) => {
            if (this.isClosed) {
                this.$scope.isLoading = false

                return
            }

            this.onShowPopup(args)
        })

        // close
        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
            this.onCloseCreateEditPopup(args)
        })

        //location selected
        this.$scope.$on(EventsNames.LOCATION_SELECTED_GMAP, (event: ng.IAngularEvent, ...args: any[]) => {
            this.onGmapLocationSelected(args)
        })

        //location-select initialized
        this.$scope.$on(EventsNames.LOCATION_SELECT_INITIALIZED, (event: ng.IAngularEvent, ...args: any[]) => {
            this.onLocationSelectInitialized(args)
        })
    }

    private onShowCreateEditPopup(): void {
        this.editedItems = {}

        this.isClosed = false
        this.$scope.popupVisible = true
        this.$scope.isLoading = true
        this.$scope.noData = false
    }

    private onShowPopup(args: any[]): void {
        if (_.size(args) > 0) {
            this.popup.show().then(() => {
                this.$scope.popupVisible = true
                this.$scope.isLoading = false
                const params: KingspanCreateEditInitparams = args[0]
                const sections: CreateEditSection[] = _.clone(params.sections)
                let initialData: CreateEditField[]
                this.idReferenceType = params.idReferenceType
                let selectedTab: number

                const opObject: IOpObject = params.referenceObject
                this.referenceObject = params.referenceObject
                const dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)

                sections.forEach((section: CreateEditSection) => {
                    section.columns = section.dataTypesToEdit.map((c: OpDataTypeInGroup) => {
                        const opDataTypeInGroup: OpDataTypeInGroup = c
                        dataTypeDict.addOrUpdate(opDataTypeInGroup.idDataType, opDataTypeInGroup.dataType)

                        const settings = {
                            id: opDataTypeInGroup.idDataType,
                            caption: opDataTypeInGroup.toString(),
                            referenceTypeId: opDataTypeInGroup.dataType.idReferenceType,// ??
                            unitName: opDataTypeInGroup.dataType.unit.name,// usunąć
                            type: opDataTypeInGroup.dataType.idDataTypeClass,//??
                            format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {},//??
                            isEditable: opDataTypeInGroup.dataType.isEditable,
                        }

                        settings['defaultValue'] = opDataTypeInGroup.dataType.defaultValue

                        return settings as CreateEditFieldSettings
                    })

                    section.required = section.dataTypesRequired.map((c: OpDataTypeInGroup) => {
                        const opDataTypeInGroup: OpDataTypeInGroup = <any>c
                        return <CreateEditFieldSettings>{
                            id: opDataTypeInGroup.idDataType,
                            caption: opDataTypeInGroup.toString(),
                            referenceTypeId: opDataTypeInGroup.dataType.idReferenceType,
                            unitName: opDataTypeInGroup.dataType.unit.name,
                            type: opDataTypeInGroup.dataType.idDataTypeClass,
                            format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {},
                            isEditable: opDataTypeInGroup.dataType.isEditable,
                        }
                    })
                })

                if (opObject) {
                    initialData = opObject.dataList
                        .toArray()
                        .map((d: IOpData) => {
                            const dataType: OpDataType = dataTypeDict.tryGetValue(d.idDataType)
                            if (dataType) {
                                return <CreateEditField>{
                                    id: d.idData,
                                    idDataType: d.idDataType,
                                    index: d.indexNBR,
                                    name: d.idDataType + '',
                                    value: d.value,
                                    typeId: dataType ? dataType.idDataTypeClass : 0,
                                    rowColor: (<any>d).statusColor
                                }
                            }
                            return null
                        })
                        .filter((d: CreateEditField) => d != null)
                }
                this.$scope.modelId = params.referenceObject ? params.referenceObject.getReferenceKey() : params.referenceObjectId
                selectedTab = params.createEditSelectedTabType

                this.originalData = _.clone(initialData)

                this.$scope.kingspanDeviceFormOptions = {
                    opLocation: <OpLocation>this.referenceObject,
                    onSubmitCallback: params.onSubmitDevice,
                    onValidationCallback: params.onValidateDevice,
                    onRunAction: params.onRunAction
                }

                this.$timeout(() => {
                    if (selectedTab) {
                        this.$scope.selectedTab = selectedTab
                    } else {
                        this.$scope.selectedTab = 0
                    }
                }, 500)

                if (!sections || sections.length == 0) {
                    this.$scope.noData = true
                } else {
                    sections.forEach((section: CreateEditSection) => {
                        if (section.dataTypesToEdit != null && section.dataTypesToEdit.length === 0) {
                            sections.splice(sections.indexOf(section), 1)
                        }
                    })
                }

                this.entityId = this.$scope.modelId

                this.updateTabs(this.$scope, sections)
                this.$scope.panels = []

                const mappedData: { [key: number]: CreateEditField } = {}

                if (initialData == null) {
                    initialData = []
                }
                initialData.forEach((data: CreateEditField) => {
                    if (data.index == 0)
                        mappedData[data.idDataType || data.id] = data
                })

                sections.forEach((section: CreateEditSection) => {
                    switch (section.type) {
                        default:
                        case "form":
                            this.createForm(section, mappedData, this.idReferenceType)
                            break;

                    }
                    this.$scope.panels.push(section)
                })

                this.$timeout(() => {
                    this.$scope.$root.$broadcast(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, this.$scope.getCoords())
                })
            })
        }
    }

    private onCloseCreateEditPopup(args: any[]): void {
        if (_.size(args) > 0) {
            this.isClosed = true

            const needClosePopup: boolean = args[1]
            if (needClosePopup != false) {
                this.$scope.popupVisible = false
            }
            this.distributorChangedEvent = null
        }
    }

    private onSectionFieldDataChanged(data: { [key: number]: CreateEditField }, dataField: number, value: any): void {
        if (data[dataField]) {
            let oldValue: any = data[dataField].value
            if (data[dataField].typeId == CommonHelper.datetime || data[dataField].typeId == CommonHelper.date) {
                oldValue = moment(oldValue).toDate()
                if ((oldValue != null || value == null) ||
                    (oldValue == null || value != null) ||
                    (oldValue != null && value != null && oldValue.getTime() != value.getTime())) {
                    this.editedItems[dataField] = true
                } else if (oldValue.getTime() == value.getTime()) {
                    this.editedItems[dataField] = false
                }
            } else {
                if (oldValue != value) {
                    this.editedItems[dataField] = true
                } else if (oldValue == value) {
                    this.editedItems[dataField] = false
                }
            }
        }
    }

    private onGmapLocationSelected(args: any[]): void {
        if (_.size(args) > 0) {
            const gmapLocationInfo = args[0]

            let city: string, address: string, street: string, nbr: string, zip: string, prevCity: string, prevAddress: string, prevZip: string

            if (this.$scope.panels && this.$scope.panels.length > 0) {
                prevCity = this.$scope.panels[0].formData[CommonHelper.locationCity]
                prevAddress = this.$scope.panels[0].formData[CommonHelper.locationAddress]
                prevZip = this.$scope.panels[0].formData[CommonHelper.locationZip]

                gmapLocationInfo[0].address_components.forEach((item: any) => {
                    if (item.types.indexOf('locality') > -1) {
                        city = item.long_name
                    }
                    if (item.types.indexOf('route') > -1) {
                        street = item.long_name
                    }
                    if (item.types.indexOf('street_number') > -1) {
                        nbr = item.long_name
                    }
                    if (item.types.indexOf('postal_code') > -1 && item.types.indexOf('postal_code_prefix') == -1) {
                        zip = item.long_name
                    }
                })
                address = (street) ? street : ''
                if (street && nbr) {
                    address += (', ' + nbr)
                }

                if (!zip || zip.length < 3) {
                    gmapLocationInfo.forEach((info: any) => {
                        if (info.types.indexOf('postal_code') > -1 && info.types.indexOf('postal_code_prefix') == -1) {
                            info.address_components.forEach(item => {
                                item.types.forEach(type => {
                                    if (type == 'postal_code')
                                        zip = item.long_name
                                })
                            })
                        }
                    })
                }

                this.$scope.panels[0].formData[CommonHelper.locationCity] = city
                this.$scope.panels[0].formData[CommonHelper.locationAddress] = address
                this.$scope.panels[0].formData[CommonHelper.locationZip] = zip

                this.editedItems[CommonHelper.locationCity] = true
                this.editedItems[CommonHelper.locationAddress] = true
                this.editedItems[CommonHelper.locationZip] = true

                if ((prevCity && prevCity != '' && prevCity != city) || (prevAddress && prevAddress != '' && prevAddress != address) || (prevZip && prevZip != '' && prevZip != zip)) {
                    const empty: string = "'" + LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData) + "'"
                    const alert: string = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.LocationAddressCompareAlert)
                    const question: string = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.LocationAddressChangeQuestion)
                    let confirmText: string = alert + '<br/>'
                    if (prevCity != city) {
                        confirmText += LocalizationHelper.getLocalizedText(LocalizationHelper.Text.City) + ': ' + (prevCity ? prevCity : empty) + ' - ' + (city ? city : empty) + '<br/>'
                    }
                    if (prevAddress != address) {
                        confirmText += LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Address) + ': ' + (prevAddress ? prevAddress : empty) + ' - ' + (address ? address : empty) + '<br/>'
                    }
                    if (prevZip != zip) {
                        confirmText += LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Zip) + ': ' + (prevZip ? prevZip : empty) + ' - ' + (zip ? zip : empty) + '<br/>'
                    }
                    confirmText += question

                    if (this.$scope.locationData == null) {
                        this.$scope.locationData = {}
                    }

                    this.$scope.locationData.city = prevCity
                    this.$scope.locationData.address = prevAddress
                    this.$scope.locationData.zip = prevZip


                    this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.locationDataChangePopupId, confirmText)
                }
            }
        }
    }

    private onLocationSelectInitialized(args: any[]): void {
        if (_.size(args) > 0 && args[0] instanceof OpLocation && this.$scope.panels && this.$scope.panels.length > 0) {
            const loc: OpLocation = <OpLocation>args[0]

            if (this.$scope.panels[0].formData[CommonHelper.locationCity] === null
                || this.$scope.panels[0].formData[CommonHelper.locationCity] === undefined) {
                this.$scope.panels[0].formData[CommonHelper.locationCity] = loc.city
                this.editedItems[CommonHelper.locationCity] = true
            }

            if (this.$scope.panels[0].formData[CommonHelper.locationAddress] === null
                || this.$scope.panels[0].formData[CommonHelper.locationAddress] === undefined) {
                this.$scope.panels[0].formData[CommonHelper.locationAddress] = loc.address
                this.editedItems[CommonHelper.locationAddress] = true
            }

            if (this.$scope.panels[0].formData[CommonHelper.locationCity] === null
                || this.$scope.panels[0].formData[CommonHelper.locationCity] === undefined) {
                this.$scope.panels[0].formData[CommonHelper.locationZip] = loc.postalCode
                this.editedItems[CommonHelper.locationZip] = true
            }
        }
    }

    //#endregion

    //#region Options

    private setOptions(): void {
        this.$scope.isLoading = true

        this.$scope.noDataText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData)
        this.$scope.confirmText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)

        this.$scope.locationDataChangePopupId = new Date().getTime() + 'location'

        //popup
        this.$scope.dateFormat = window['simax'].getDateFormat('DATE_FORMAT_DX')
        this.$scope.popupVisible = false

        this.$scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible',
                title: 'options.title',
            },
            fullScreen: false,
            showTitle: true,
            closeOnOutsideClick: false,
            maxWidth: (): number => { return $(window).width() * 0.7 },
            height: (): number => { return $(window).height() * 0.9 },
            onHiding: (e: any): void => this.closePopup(),
            onInitialized: (e: any): void => {
                this.popup = e.component
            },
            onShowing: (e: any): void => {
                this.previousSectionState = ""
            }
        }

        //tabs
        this.$scope.selectedTab = -1
        this.$scope.tabItems = []
        this.$scope.tabsOptions = {
            bindingOptions: {
                visible: 'tabsVisible',
                items: 'tabItems',
                selectedIndex: 'selectedTab'
            },
            onInitialized: (e: any): void => {
                this.tabs = e.component
            },
            onSelectionChanged: (e: any): void => {
                if (this.$scope.panels && this.$scope.panels[this.$scope.selectedTab] && this.$scope.panels[this.$scope.selectedTab].grid) {
                    this.$scope.panels[this.$scope.selectedTab].grid.refresh()
                }
            }
        }

        this.$scope.closeButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, this.userSession),
            onClick: (e: any) => this.closeDetails()
        }

        this.$scope.toolbarOptions = {
            items: [{
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
                    onClick: (): void => {
                        this.submit()
                    }
                }
            }]
        }

        // location select callbacks
        this.$scope.getCoords = (): OpCoord => {
            return this.getCoords()
        }

        this.$scope.onLocationSelected = (lat: number, lng: number): void => {
            this.onLocationSelected(lat, lng)
        }

        this.$scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null, value: string = null): void => {
            this.onPopoverValueIdSelected(valueId, datatypeId)

            this.selectedPopoverData = this.selectedPopoverData.filter((item: SelectPopoverData) => { return item.dataTypeId != datatypeId })
            this.selectedPopoverData.push({ valueId: valueId, dataTypeId: datatypeId, value: value })
        }

        //change previouse location data
        this.$scope.confirmNoChangePrevLocationData = (): void => {
            this.$scope.panels[0].formData[CommonHelper.locationCity] = this.$scope.locationData.city
            this.$scope.panels[0].formData[CommonHelper.locationAddress] = this.$scope.locationData.address
            this.$scope.panels[0].formData[CommonHelper.locationZip] = this.$scope.locationData.zip

            this.$scope.panels[0].formData[CommonHelper.locationLatitude] = this.$scope.locationData.lat
            this.$scope.panels[0].formData[CommonHelper.locationLongitude] = this.$scope.locationData.lng

            this.$scope.$broadcast(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, this.$scope.getCoords())

            this.getCoords()
        }

        this.$scope.kingspanAccordionsOptions = {
            disableCollapsing: false
        }

        this.$scope.kingspanFormAccordionItemOptions = {
            expanded: true,

            toolbar: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.LocationParameters),
            },
        }

        this.$scope.kingspanDeviceAccordionItemOptions = {
            expanded: true,

            toolbar: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeviceParameters),
            },
        }
    }

    private getFormOptions(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number): DevExpress.ui.dxFormOptions {
        const formOptions: DevExpress.ui.dxFormOptions = {
            requiredMark: '*',
            showRequiredMark: true,
            labelLocation: 'top',
            width: '100%',
            height: '100%',
            scrollingEnabled: true,
            colCount: 4,
            bindingOptions: {
                formData: 'panel.formData',
                items: 'panel.items',
            },
            onInitialized: (e: any): void => {
                section.form = e.component

                this.$timeout(() => {
                    this.loadForm(section, data, this.$scope.options.type, idReferenceType)
                })

                //dedicated
                if (section.formData != null
                    && !section.formData[Enums.DataType.LOCATION_WARRANTY_DATE]
                    && section.columns.some((column: CreateEditFieldSettings) => column.id == Enums.DataType.LOCATION_WARRANTY_DATE)) {
                    const d: Date = new Date();
                    section.formData[Enums.DataType.LOCATION_WARRANTY_DATE] = new Date(d.getFullYear() + 2, d.getMonth(), d.getDate())
                }

            },
            onFieldDataChanged: (e: any): void => {
                this.onSectionFieldDataChanged(data, e.dataField, e.value)
                this.trackChanges(section, e.dataField, e.value)
            },
        }
        return formOptions
    }

    //#endregion

    //#region Custom    

    private closeDetails(): void {
        this.isClosed = true

        this.$scope.popupVisible = false
        if (this.$scope != null && this.$scope.options != null && this.$scope.options.onClose != null && TypeHelper.isFunction(this.$scope.options.onClose)) {
            this.$scope.options.onClose()
        }
    }

    private updateTabs($scope: KingspanCreateEditScope, sections: CreateEditSection[]): void {
        $scope.tabItems = sections.map((section: CreateEditSection) => {
            return {
                template: (itemData: any, itemIndex: number, itemElement: HTMLElement): string => {
                    this.$scope['showSectionError' + itemIndex] = false
                    return section.name + '<ng-md-icon ng-show="showSectionError' + itemIndex + '" icon="' + window['config']['ICONS']['REQUIRED_TAB'] + '" style="fill: #ea4444; vertical-align: middle;" size="20"></ng-md-icon>'
                }
            }
        })
        $scope.tabsVisible = $scope.tabItems.length > 1
    }

    private updateFormData(section: CreateEditSection, dataField: string | number, value: any): void {
        if (section.formData[dataField] != value) {
            section.formData[dataField] = value
            this.editedItems[dataField] = true
        }
    }

    private createForm(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number): void {
        section.formData = {}
        section.items = []

        section.onFieldChanged = (e: any, idDataType: number = null): void => {
            const dataField: string = idDataType || e.element.get(0).attributes['table-id'].nodeValue
            if (dataField) {
                let value: any = null
                if (e.selectedItem) {
                    let number: number = parseFloat(e.selectedItem.id)
                    if (!isNaN(number))
                        value = number
                    else
                        value = e.selectedItem.id
                }

                this.updateFormData(section, dataField, value)
            }
        }

        section.onDateFieldChanged = (e: any): void => {
            this.trackChanges(section, e.element.get(0).attributes['table-id'].nodeValue, e.value)
        }

        section.onFieldValueChanged = (e: any): void => { console.log(e) } //empty but probaly necessary to avoid error

        section.initializedHandler = (e: any): void => { }  //empty but probaly necessary to avoid error

        section.onSelectNoteValueChanged = (value: ChangeStatusSelectItem, idDataType: Enums.DataType): void => {
            if (value != null) {
                $("[table-id=" + idDataType + "] .dx-dropdownbox").removeClass('dx-invalid')

                this.updateFormData(section, idDataType, value.value)
            }
        }

        section.onNoteValueChanged = (value: string, idDataType: Enums.DataType): void => {
            if (value != null) {
                this.updateFormData(section, idDataType, value)
            }
        }

        section.options = null
        this.$timeout(() => {
            section.options = this.getFormOptions(section, data, idReferenceType)
        })
    }

    private trackChanges(section: CreateEditSection, idDataType: number, value: any, index: number = 0): void {
        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel != section) {
                if (panel.form && index == 0 && panel.columns.map(c => c.id).indexOf(idDataType) > -1) {
                    if (idDataType == CommonHelper.distributorColumnId && this.distributorFormInstance) {
                        this.hideDistributorChangePopup = true
                        this.distributorFormInstance.option('value', value)
                        this.hideDistributorChangePopup = false
                    }

                    if (panel.formData[idDataType] != value) {
                        this.editedItems[idDataType] = true
                        panel.formData[idDataType] = value
                    }
                }
            }
        })
    }

    private getId(index: number, idDataType: number): number {
        if (this.originalData != null) {
            const models: CreateEditField[] = this.originalData.filter((d: CreateEditField) => d.index == index && d.idDataType == idDataType)
            if (models.length > 0) {
                return models[0].id
            }
        }
        return null
    }

    private submit(): void {
        const sections: CreateEditSection[] = this.$scope.panels

        if (this.isSectionsValid(sections) == true) {
            let unique: { index: number, idDataType: number }[] = []
            let fields: FieldNameValueModel[] = []

            sections.forEach((section: CreateEditSection) => {
                if (section.form != null) {
                    Object.keys(section.formData).forEach((property: string) => {
                        let idDataType: number = parseInt(property)
                        if (unique.filter((o: { index: number, idDataType: number }) => o.index == 0 && o.idDataType == idDataType).length == 0) {
                            const id: number = this.getId(0, idDataType)
                            let state: Enums.OpChangeState = Enums.OpChangeState.New
                            let isHelperField: boolean = false
                            const dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(idDataType)
                            if (dataType != null) {
                                isHelperField = dataType.name.indexOf('HELPER_') == 0
                            }
                            if (id || isHelperField) {
                                if (this.editedItems[idDataType]) {
                                    state = Enums.OpChangeState.Modified
                                } else {
                                    state = Enums.OpChangeState.Loaded
                                }
                            }
                            let nameValue: FieldNameValueModel = new FieldNameValueModel()
                            nameValue.idDataType = idDataType
                            nameValue.id = id ? id : 0
                            nameValue.index = 0
                            nameValue.value = section.formData[property]

                            if (dataType != null) {
                                nameValue.value = ConvertHelper.prepareDataValue(nameValue.value, dataType)
                            }

                            nameValue.state = state
                            fields.push(nameValue)
                            unique.push({ index: 0, idDataType: idDataType })
                        }
                    })
                }
            })

            let currentMd5: string = Md5.init({ fields, entityId: this.entityId })
            if (this.previousSectionState !== currentMd5 || this.submitFailed) {
                this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
                this.previousSectionState = currentMd5

                const objectToSave: IOpObject = <IOpObject><any>ReferenceTypeComponent.createReferenceObject(this.idReferenceType, {})
                objectToSave.idObject = this.entityId
                objectToSave.dataList = new OpDataList<IOpData>()
                fields.forEach((f: FieldNameValueModel) => {
                    const objectDataToSave: IOpData = <IOpData>{}
                    objectDataToSave.idDataType = f.idDataType
                    objectDataToSave.indexNBR = f.index
                    objectDataToSave.value = f.value
                    objectDataToSave.opState = f.state
                    objectToSave.dataList.push(objectDataToSave)
                })
                objectToSave.opState = objectToSave.idObject == 0 ? Enums.OpChangeState.New : Enums.OpChangeState.Modified

                this.$scope
                    .options
                    .onSave(objectToSave)
                    .then((result: IOpObject) => {
                        if (!result) {
                            this.submitFailed = true
                        } else {
                            this.submitFailed = false
                        }
                    })
                    .catch(() => {
                        this.submitFailed = true
                    })
                    .finally(() => {
                        this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                    })
            }
        }
        else {
            ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IncorrectData), { displayTime: 5000 })
            angular.element('.dx-invalid').css('height', '36px')
        }
    }

    private getCoords(): OpCoord {
        let latitude: number
        let longitude: number
        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel.formData == null) {
                return
            }

            const lat: number = panel.formData[CommonHelper.locationLatitude]
            const lng: number = panel.formData[CommonHelper.locationLongitude]
            if (lat != null && lng != null) {
                latitude = lat
                longitude = lng
            }
        })
        if (latitude != null && longitude != null) {
            let coord: OpCoord = new OpCoord()
            coord.latitude = latitude
            coord.longitude = longitude
            return coord
        }
        return null
    }

    private onLocationSelected(lat: number, lng: number): void {
        if (this.$scope.locationData == null) {
            this.$scope.locationData = {}
        }

        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel.form != null && panel.formData != null) {
                this.$scope.locationData.lat = panel.formData[CommonHelper.locationLatitude]
                this.$scope.locationData.lng = panel.formData[CommonHelper.locationLongitude]

                panel.formData[CommonHelper.locationLatitude] = lat
                panel.formData[CommonHelper.locationLongitude] = lng
                this.editedItems[CommonHelper.locationLatitude] = true
                this.editedItems[CommonHelper.locationLongitude] = true
            }
        })
    }

    private onPopoverValueIdSelected(valueId: number, datatypeId): void {
        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel.form != null && panel.formData != null) {
                if (panel.formData[datatypeId] !== undefined) {
                    if (valueId) {
                        angular.element('.data_type_id_' + datatypeId).find('.dx-invalid').removeClass('dx-invalid')
                    }
                    panel.formData[datatypeId] = valueId
                    this.editedItems[datatypeId] = true
                }
            }
        })
    }

    private closePopup(): void {
        this.isClosed = true
        this.$scope.panels = []
        this.selectedPopoverData = []
        this.$scope.kingspanDeviceFormOptions = null
    }

    //#endregion    
}
